import { SET_USER, LOGOUT } from "../actions";

const getUserData = () => {
  try {
    const data = localStorage.getItem("user_data");
    return data ? JSON.parse(data) : {};
  } catch (error) {
    console.error("Error parsing user_data from localStorage:", error);
    return {};
  }
};

const initialState = {
  user_data: getUserData(),
};

const userReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_USER:
      localStorage.setItem("user_data", JSON.stringify(action.payload));
      return {
        ...state,
        user_data: action.payload,
      };

    case LOGOUT:
      return { ...initialState }; // Reset state without affecting localStorage

    default:
      return state;
  }
};

export default userReducer;
